/**
 * InstantMessagingDrawer — floating right-side panel (380px) used from any pro
 * page. Triggered by the topbar chat icon. Pressing Escape or clicking the
 * overlay closes it.
 */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import InstantMessagingChat from "./InstantMessagingChat";

export default function InstantMessagingDrawer({ open, onClose }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[120]" data-testid="im-drawer">
      <div
        onClick={onClose}
        data-testid="im-drawer-overlay"
        className="absolute inset-0 bg-black/55 backdrop-blur-[2px] animate-[fadeIn_.15s_ease]"
      />
      <aside
        className="absolute top-0 right-0 h-full w-full sm:w-[380px] bg-[var(--mc-navy-950)] border-l border-[rgba(127,179,255,0.22)] shadow-2xl flex flex-col"
        style={{ animation: "slideInRight .22s ease" }}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-[rgba(127,179,255,0.18)]">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[var(--mc-mint)]">Messagerie instantanée</div>
          <button
            onClick={onClose}
            data-testid="im-drawer-close"
            className="grid place-items-center h-7 w-7 rounded-md border border-[rgba(127,179,255,0.22)] text-[var(--mc-blue-200)] hover:text-white"
          >
            <X size={14} />
          </button>
        </div>
        <div className="flex-1 min-h-0">
          <InstantMessagingChat
            variant="drawer"
            onClose={onClose}
            onTogglePage={() => {
              onClose();
              navigate("/mssante/espace/messagerie-instantanee");
            }}
          />
        </div>
      </aside>
      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideInRight { from { transform: translateX(100%); opacity: .9 } to { transform: translateX(0); opacity: 1 } }
      `}</style>
    </div>
  );
}
